function cov_3rlw38br5() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronLeft12.tsx";
  var hash = "31c54b946507545ca17f20825405833543fad39a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronLeft12.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 55
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "31c54b946507545ca17f20825405833543fad39a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_3rlw38br5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_3rlw38br5();
var Icon = (cov_3rlw38br5().s[0]++, {
  name: 'chevron-left-12',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.88388 9.88388C8.39573 10.372 7.60427 10.372 7.11612 9.88388L4.11612 6.88388C3.62796 6.39573 3.62796 5.60427 4.11612 5.11612L7.11612 2.11612C7.60427 1.62796 8.39573 1.62796 8.88388 2.11612C9.37204 2.60427 9.37204 3.39573 8.88388 3.88388L6.76777 6L8.88388 8.11612C9.37204 8.60427 9.37204 9.39573 8.88388 9.88388Z\" fill=\"currentColor\"/>"
});
export default Icon;